<template>

<div class="input-container">
　<label><span class="label-text">{{label}}</span><span v-if="showRequireTag" class="tag">必須</span><span v-if="showNotRequireTag" class="tag not-required">任意</span></label>
              <div v-bind:class="{focus: IsFocus == true,error:isShowErrorMessage}"
              v-if="readonly===false"
              :style="{borderRadius:radius }"
               class="c-title-edit">
                  <i :class="[iconClassName]" ></i>
                  <div class="split-border">&nbsp;</div>
                  <!-- <input type="text"
                    :placeholder="placeholder"
                    v-model="text"
                    @focus="IsFocus=true"
                    @blur="IsFocus=false"
                    @keyup.enter="Edited"
                    @keypress="SetCanMessageSubmit"
                    > -->
                    <input :type="inputType"
                    v-validate="'required|email'"
                    ref="tinput"
                    :maxlength="maxlength"
                    :placeholder="placeholder"
                    @focus="IsFocus=true"
                    @blur="IsFocus=false"
                    @keydown.enter="Edited"
                    :value="value"
                    @input="updateText"
                    >
                  <span @click="ResetInput()" v-show="IsShowRemoveInput" class="fas fa-times-circle"></span>
              </div>  
              <div v-if="readonly===true" v-bind:class="{focus: IsFocus == true}"
              :style="{borderRadius:radius }"
               class="c-title-readonly">
                  <i :class="[iconClassName]" ></i>
                  <div class="split-border">&nbsp;</div>
                  <span class="disp-value">{{value}}</span>
              </div>  
    <!-- 値の検証時エラーメッセージ -->
    <div class="validate-error-message" v-if="isShowErrorMessage">
      <i class="fas fa-exclamation-triangle"></i>{{this.errorMessage}}
    </div>
</div>	
</template>

<script>
export default {
  name: "t-input",
  props: { 
    readonly:{type:Boolean,default:false},//読み取り専用モード
    value: { type: String, default: "+++" },
    maxlength:{type:Number,default:100},
    inputType:{type:String, default:"text"},//textかパスワードか
    placeholder: { type: String, default: ""},
    iconClassName: { type: String, default: "fas fa-edit" },
    radius:{type:String,default:"6px"},
    label:{type:String,default:""},
    enterToEditEnd:{type:Boolean,default:false},
    isShowErrorMessage:{type:Boolean,default:false},//エラー文字の表示
    errorMessage:{type:String,default:""},//エラー文字
    showRequireTag:{type:Boolean,default:false},
    showNotRequireTag:{type:Boolean,default:false},

  },
  data() {
    return {
      IsFocus: false,
      IsShowRemoveInput: false,
      text:this.value
    };
  },
  watch: {
    value: function() {
      if (this.value.length > 0) {
        this.IsShowRemoveInput = true;
        return;
      }
      this.IsShowRemoveInput = false;
    }
  },
  mounted() {},
  methods: {
    updateText(e) {
      this.$emit("input", e.target.value);
    },
    ToFocus(){
      this.$nextTick(() => {
        this.$refs.tinput.focus(); 
      })
      

    },
    Edited(event) {
　　　　
      if(false===this.enterToEditEnd)
      {
        return;
      }

      console.log("edited"+event.keyCode);


      // 日本語入力中のEnterキー操作は無効にする
      if(event.keyCode!==13) {
        return;
      }

      this.$emit("edited", this.value);
      this.ResetInput();
    },
    ResetInput() {
      this.value = "";
      this.$emit("input", "");//通知する必要あり
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin placeholderColor($color) {
  &:placeholder-shown {
    color: $color;
    font-weight: normal;
  }
  &::-webkit-input-placeholder {
    color: $color;
    font-weight: normal;
  }
  &:-moz-placeholder {
    color: $color;
    opacity: 1;
  }
  &::-moz-placeholder {
    color: $color;
    opacity: 1;
  }
  &:-ms-input-placeholder {
    color: $color;
  }
}

.input-container{
  position: relative;
  margin-bottom:22px;

  &>label{
    font-weight: 600;
    display: block;
    margin-bottom:3px;
    margin-left:8px;
    font-size:14px;
    color: #42b983;
    &>.label-text{
      display: inline-block;
    }
  }

  //必須、任意タグ
  .tag{
    letter-spacing: 3px;
    margin-left:5px;
    box-sizing: border-box;
    border:3px solid rgb(250, 146, 108);
    background:rgb(250, 97, 42);
    color:white;
    border-radius: 13px;
    padding: 1px 8px;
    font-size:12px;
    font-weight: bold;
    display: inline-block;

    &.not-required{
      border:5px solid #888;
      background:#666;
    }
  }
  
}

//---------------
// 検証エラーメッセージ：スタイル
//---------------
.validate-error-message{
  position: absolute;
  padding-top:5px;
  font-size:14px;
  left:20px;
  font-weight: 600;
  color:rgb(250, 97, 42);
  //background:rgb(250, 204, 188);
  & > i{
    margin-right: 8px;
  }
}


//===========================
//読み取り専用スタイル
//===========================
.c-title-readonly{
  position:relative;
  transition: 0.3s;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;

  & > i {
    margin-left: 20px;
    font-size: 20px;
    color: #42b983;
    transition: 0.3s;
  }

  & > div.split-border{
    flex: 0;
    opacity:0.5;
    margin-left:18px;
    height:60%;
    display: inline-block;
    border-left:solid 2px #42b983;
  }

  & > .disp-value {
    border: none;
    color: #42b983;
    font-weight: bold;
    flex: 1;
    font-size: 14px;
    margin-left: 16px;
  }
}

//===========================
//編集スタイル
//===========================
.c-title-edit {
  position:relative;
  // border-radius: 6px;
  transition: 0.3s;
  background: #f2faf6;
  &:hover {
    //border-width: 2px;
  }
  &.focus {
    //border: 4px solid #42b983;
    box-shadow:0px 0px 6px 1px #5eb48e;
    
    background: #f2faf6;

    & > i {
      color: #42b983;
    }
    & > input {
      @include placeholderColor(#42b98380);
    }
  }

  //======================
  //validateError時のスタイル
  &.error{
    border:1px solid rgb(250, 97, 42);
    //background:rgba(250, 97, 42,0.2);

    & > i{
      color:rgb(250, 97, 42);
    }
    & > div.split-border{
      border-left:solid 2px rgb(250, 97, 42);
    }
    & > input {
      color: rgb(250, 97, 42);
      @include placeholderColor(rgb(250, 97, 42));
    }
  }

  border: 2px solid #42b983;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;

  & > i {
    margin-left: 20px;
    font-size: 20px;
    color: #42b983;
    transition: 0.3s;
  }

  & > div.split-border{
    flex: 0;
    opacity:0.5;
    margin-left:18px;
    height:60%;
    display: inline-block;
    border-left:solid 2px #42b983;
  }

  & > input {
    border: none;
    //color: #42b983;
    color:#666;
    font-weight: bold;
    outline-width: 0;
    height: 100%;
    flex: 1;
    font-size: 14px;
    margin-left: 16px;
    margin-right:40px;
    background: transparent;
    @include placeholderColor(#42b983);

    &:focus{
      outline:none;//safariでフォーカス時に線がでるのを防ぐ
    }
  }

  & > span {
    position: absolute;
    right: 13px;
    font-size: 22px;
    color: #42b983;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TInput.vue